import { useSelector } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates } from '@/constants/lifecycle';

// Tying allowRefresh to update permission as only those who can change datasets really need
// the ability to refresh, users who can't will generally find the option superfluous
const useDatasetMarkdownActions = ({ category, code }) => useSelector(({
  auth: { role: { permissions: { datasets: { download: allowDownload, read: allowRead, update: allowRefresh } } } },
  datasetMarkdown: { markdowns },
}) => {
  const { readStatus, text } = findResult(markdowns, category, code) || { text: '', ...readStates };

  return {
    allowDownload, allowRead, allowRefresh, readStatus, text,
  };
});

const useDatasetMarkdownPanelAll = ({ category, code }) => useSelector(({
  auth: { role: { permissions: { datasets: { download: canRead } } } },
  datasetMarkdown: { markdowns },
}) => {
  const item = findResult(markdowns, category, code) || { text: '', catalogue: { title: '' }, ...readStates };

  return {
    canRead,
    name: item.catalogue?.title,
    readErrors: item.readErrors,
    readStatus: item.readStatus,
    text: item.text,
  };
});

export default {
  useDatasetMarkdownActions,
  useDatasetMarkdownPanelAll,
};
